import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatButtonModule} from '@angular/material/button';

import { ReviewComponent } from './review.component';
import { AuthGuard } from '../../guards/auth.guard';
import { VarModule } from '../../directives/ngVar';
import { ListingModule } from '../../components/listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { CompassReviewDialog } from '../../components/compass-review-dialog/compass-review-dialog.component';
import { CompassReviewDialogModule } from '../../components/compass-review-dialog/compass-review-dialog.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        VarModule,
        ListingModule,
        DirectivesModule,
        MatButtonModule,
        CompassReviewDialogModule,
        RouterModule.forChild([
            {
                path: 'products',
                canActivate: [AuthGuard],
                component: ReviewComponent,
                children: [],
                data: { roles: 'ROLE_COMPASS_REVIEW' }
            }
        ])
    ],
    declarations: [
        ReviewComponent
    ],
    exports: [
        ReviewComponent
    ]
})
export class ReviewModule { }
